import React, { useState, useEffect } from "react";
import { Text, TextInput, View, FlatList, StyleSheet, Image, TouchableOpacity, Modal } from "react-native";

import WooService from "../services/WooService";

const balanceMsg = "Insira o valor presente no caixa"

const CashBalanceScreen = ({ route, navigation }) => {
  const [balanceHeader, setBalanceHeader] = useState();
  const [billCounter, setBillCounter] = useState([]);
  const [coinCounter, setCoinCounter] = useState([]);
  const [counterTotal, setCounterTotal] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);

  const { action, callback } = route.params;

  const wooService = new WooService();

  const bills = [
    {code: 'bill-100', description: 'R$ 100', value: 10000, img: require('../../assets/cedula-100.png')},
    {code: 'bill-50', description: 'R$ 50', value: 5000, img: require('../../assets/cedula-50.png')},
    {code: 'bill-20', description: 'R$ 20', value: 2000, img: require('../../assets/cedula-20.png')},
    {code: 'bill-10', description: 'R$ 10', value: 1000, img: require('../../assets/cedula-10.png')},
    {code: 'bill-5', description: 'R$ 5', value: 500, img: require('../../assets/cedula-5.png')},
    {code: 'bill-2', description: 'R$ 2', value: 200, img: require('../../assets/cedula-2.png')},
  ];

  const coins = [
    {code: 'coin-100', description: 'R$ 1,00', value: 100, img: require('../../assets/moeda-100.png')},
    {code: 'coin-50', description: 'R$ 0,50', value: 50, img: require('../../assets/moeda-50.png')},
    {code: 'coin-25', description: 'R$ 0,25', value: 25, img: require('../../assets/moeda-25.png')},
    {code: 'coin-10', description: 'R$ 0,10', value: 10, img: require('../../assets/moeda-10.png')},
    {code: 'coin-5', description: 'R$ 0,05', value: 5, img: require('../../assets/moeda-5.png')},
  ];

  useEffect(() => {
    if (billCounter.length === 0) {
      let amounts = [];
      for (const bill of bills) {
          amounts.push({...bill, count: 0});
      }
      setBillCounter(amounts);
    }
    if (coinCounter.length === 0) {
      let amounts = [];
      for (const coin of coins) {
          amounts.push({...coin, count: 0});
      }
      setCoinCounter(amounts);
    }
    if (action === "open") {
      setBalanceHeader("Abertura do Caixa");
    } else if (action === "close") {
      setBalanceHeader("Fechamento do Caixa");
    }
  }, []);

  const updateBillCounter = (code, count) => {
      let amounts = billCounter;
      for (var amount of amounts) {
        if (amount.code === code) {
          amount.count = count;
        }
      }
      setBillCounter(amounts);
      sumCounters();
  }

  const updateCoinCounter = (code, count) => {
    let amounts = coinCounter;
    for (var amount of amounts) {
      if (amount.code === code) {
        amount.count = count;
      }
    }
    setCoinCounter(amounts);
    sumCounters();
  }

  const sumCounters = () => {
    console.log(billCounter);
    let total = billCounter.reduce((accum, amount) => {
      return accum + amount.value * amount.count;
    }, 0);
    total += coinCounter.reduce((accum, amount) => {
      return accum + amount.value * amount.count;
    }, 0);
    total /= 100;
    setCounterTotal(total.toFixed(2));
  }

  const saveCashBalance = async () => {
    try {
      if (action === "open") {
        const response = await wooService.openBalance(parseInt(counterTotal*100));
        console.log(response);
        setModalVisible(false);
        callback();
        navigation.goBack();
      } else {
        setModalVisible(false);
        navigation.navigate("BalanceEntries", {action: "close", closeCash: counterTotal, callback: callback});
      }
    }
    catch(error) {
      alert("Ocorreu um erro no acesso ao servidor.\nTente novamente em alguns instantes. Erro: ", error);
      setModalVisible(false);
    }
  }

  return (
    <View>
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}>
        <View style={styles.modalView}>
          <Text style={styles.modalText}>Confirma o registro de R$ {counterTotal} ?</Text>
          <View style={{marginTop: 30}}>
            <TouchableOpacity style={styles.buttons} onPress={() => saveCashBalance()}>
                <Text style={styles.buttonText}>Confirmar</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.buttons} onPress={() => setModalVisible(false)}>
                <Text style={styles.buttonText}>Voltar</Text>
            </TouchableOpacity>
          </View>
        </View>     
      </Modal>
      <View style={styles.layout}>
        <View style={{alignItems: 'center'}}>
          <Text style={styles.balanceHeader}>{balanceHeader}</Text>
          <Text style={styles.balanceMessage}>{balanceMsg}</Text>
          <View style={{flexDirection: 'row'}}>
            <View style={styles.amountsColumns}>
              <FlatList
              LisHeaderComponent={<Text></Text>}
              ListFooterComponent={<Text></Text>}
              contentContainerStyle={styles.listStyle}
              numColumns={1}
              data={billCounter}
              keyExtractor={bill => bill.code}
              renderItem={({ item }) => {
                  return (
                  <View style={styles.moneyItem}>
                      <Image style={{height: 60, resizeMode: 'contain'}} source={item.img}></Image>
                      <TextInput
                          style={styles.textInput}
                          keyboardType="numeric"
                          placeholder={item.count}
                          onChangeText={(text) => {
                            updateBillCounter(item.code, text);
                          }}
                      />
                  </View>
                  );
              }}
              />
            </View>
            <View style={styles.amountsColumns}>
              <FlatList
              LisHeaderComponent={<Text></Text>}
              ListFooterComponent={<Text></Text>}
              contentContainerStyle={styles.listStyle}
              numColumns={1}
              data={coinCounter}
              keyExtractor={coin => coin.code}
              renderItem={({ item }) => {
                  return (
                  <View style={styles.moneyItem}>
                      <Image style={{height: 60, resizeMode: 'contain'}} source={item.img}></Image>
                      <TextInput
                          style={styles.textInput}
                          keyboardType="numeric"
                          placeholder={item.count}
                          onChangeText={(text) => {
                              updateCoinCounter(item.code, text);
                          }}
                      />
                  </View>
                  );
              }}
              />
            </View>
          </View>
          <View style={styles.balanceAmounts}>
            <TouchableOpacity style={styles.buttons} onPress={() => navigation.goBack()}>
              <Text style={styles.buttonText}>Voltar</Text>
            </TouchableOpacity>
            <Text style={styles.totalHeader}>Total: R$ {counterTotal}</Text>
            <TouchableOpacity style={styles.buttons} onPress={() => setModalVisible(true)}>
              <Text style={styles.buttonText}>Registrar</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  layout: {
    justifyContent: 'center',
    flex: 1
  },
  totalHeader: {
    color: 'rgb(150, 94, 17)', 
    fontSize: 16, 
    fontWeight: 'bold', 
    paddingHorizontal: 20
  },
  balanceHeader: {
    color: 'rgb(150, 94, 17)', 
    fontSize: 24,
    fontWeight: 'bold',
    marginTop: 20
  },
  balanceMessage: {
    fontSize: 20,
    fontWeight: 'bold',
    marginVertical: 10
  },
  balanceAmounts: {
    marginVertical: 10,
    flexDirection: 'row',
    alignItems: 'center'
  },
  amountsColumns: {
    alignItems: 'center',
    marginHorizontal: 20
  },
  listStyle: {
    margin: 5
  },
  moneyItem: {
    marginBottom: 15
  },
  textInput: {
    textAlign: 'center',
    width: 100,
    backgroundColor: '#ccc',
    fontSize: 18
  },
  buttons: {
    backgroundColor: '#965E11',
    width: 160,
    marginVertical: 10,
    padding: 10,
    borderRadius: 10,
    alignSelf: 'center'
  },
  buttonText: {
      fontSize: 18,
      fontWeight: 'bold',
      alignSelf: 'center',
      color: 'white'
  },
  modalView: {
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    marginTop: 100,
    backgroundColor: "white",
    borderRadius: 20,
    paddingVertical: 50,
    paddingHorizontal: 70,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5
  },
  modalText: {
    fontSize: 16,
    fontWeight: "bold"
  }
});

export default CashBalanceScreen;